
export default function loader () {
	return {
		restrict: 'E',
		scope: {},
		bindToController: true,
		template: require('./loader.html'),
		transclude: true,
		controller: 'LoaderController',
		controllerAs: 'loader'
	}
};

loader.$inject = [];



// WEBPACK FOOTER //
// ./src/directive/loader/loader.js